import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { GeneralInfoForm } from "components/SMSVendor";

export default () => {

 
  return (
    <>
    <Card border={1}>
      <Row>
        <Col xs={12} xl={12}>
          <GeneralInfoForm />
        </Col>
      </Row>
    </Card>
  </>
  );
};
